import { useState } from 'react';
import ContainerCard from '../../../../common/components/ContainerCard';
import { IAddress } from '../../../../models/Account/IAddress';
import styles2 from '../../AccountPage.module.css';
import styles from './AddressesSection.module.css';
import AddressCard from './components/AddressCard';
import AddressModal from './components/AddressModal';


type AddressesProps = {
  addresses: IAddress[];
  onAddAddress: (newAddress: IAddress) => Promise<any>;
  onUpdateAddress: (address: IAddress) => Promise<any>;
  onDeleteAddress: (address: IAddress) => void;
  onChangeCountry: (countryCode: string) => Promise<any>;
  fetchStates: (countryCode: string) => Promise<any>;
};

const AddressesSection = (props: AddressesProps) => {
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [existingAddress, setExistingAddress] = useState<IAddress>({} as IAddress);
  const [editMode, setEditMode] = useState(false);

  const toggleAddressModal = () => {
    setShowAddressModal(!showAddressModal);
  };

  const onAddEditAddress = (address: IAddress) => {
    if (editMode) {
      return props.onUpdateAddress(address);
    } else {
      return props.onAddAddress(address);
    }
  };

  const handleAddressEdit = async (address: IAddress) => {
    setExistingAddress(address);
    setShowAddressModal(!showAddressModal);
    setEditMode(true);
  };



  const handleAddAddress = async () => {
    setExistingAddress({
      countryCode: 'US',
    } as IAddress);
    setShowAddressModal(!showAddressModal);
    setEditMode(false);
    // }
  };

  const handleAddressDelete = (address: IAddress) => {
    props.onDeleteAddress(address);
  };

  const onChangeCountry = (countryCode: string) => {
    return props.onChangeCountry(countryCode);
  };

  const fetchStates = (countryCode: string): Promise<any> => {
    return props.fetchStates(countryCode);
  };

  return (
    <>
      {showAddressModal && (
        <AddressModal
          existingAddress={existingAddress}
          addresses={props.addresses}
          addressModalClose={toggleAddressModal}
          onAddEditAddress={onAddEditAddress}
          onChangeCountry={onChangeCountry}
          fetchStates={fetchStates}
        />
      )}
      <ContainerCard className={styles2.cardDimensions + ' ' + styles2.cardStrech}>
        <div className={styles.title}>ADDRESSES</div>
        <div className={styles.addressesCardContainer}>
          {props.addresses?.map((item, index) => {
            return (
              <AddressCard
                key={index}
                addressData={item}
                onEdit={handleAddressEdit}
                onDelete={handleAddressDelete}
              />
            );
          })}
          <ContainerCard className={styles.plusCardDimensions}>
            <div className={styles.centralContainer} onClick={handleAddAddress}>
              <div className={styles.plusSign} />
              <div className={styles.labelBig}>Add New</div>
            </div>
          </ContainerCard>
        </div>
      </ContainerCard>
    </>
  );
};

export default AddressesSection;
